export enum ReportsEstateSelected {
  ALL_PROJECTS = "All Projects",
}
